import angular from 'angular';
import uiRouter from 'angular-ui-router';
import angularOAuth2 from 'angular-oauth2';
import config from '../../config/config';

import authConfig from './auth.config';
import authRun from './auth.run';
import authService from './auth.service';
import authInterceptor from './auth.interceptor';
import cacheService from '../../services/cache.service';

const authModule = angular.module('authService', [
    uiRouter,
    angularOAuth2.name,
    config,
    cacheService
])
    .config(authConfig)
    .config($httpProvider => {
        'ngInject';
        $httpProvider.interceptors.push('authInterceptor');
    })
    .factory('authInterceptor', authInterceptor)
    .run(authRun)
    .service('authService', authService)
    .name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.js